import { render } from "./MsThOptionDate.vue?vue&type=template&id=5dd770c6"
import script from "./MsThOptionDate.vue?vue&type=script&lang=js"
export * from "./MsThOptionDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__